import { render, staticRenderFns } from "./ForumSearch.vue?vue&type=template&id=12cbdfb6&scoped=true"
import script from "./ForumSearch.vue?vue&type=script&lang=js"
export * from "./ForumSearch.vue?vue&type=script&lang=js"
import style0 from "./ForumSearch.vue?vue&type=style&index=0&id=12cbdfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbdfb6",
  null
  
)

export default component.exports